import { selectTitleNode } from '@newStore/documentUI/transformContent/genericSelectors';
import { NodeType, type RootNodeConfig } from '@nodeTypeConfig/configTypes';
import { authorsComponent } from '@nodeTypeConfig/helpers/editComponents/authorsComponent';
import { titleComponent } from '@nodeTypeConfig/helpers/editComponents/titleComponent';
import { referenceFrameDeleteValidationCmd } from '@store/commands/documentListCommands';

const REFERENCE_FRAME: RootNodeConfig = {
  nodeSelector: selectTitleNode,
  deleteFromListValidations: [referenceFrameDeleteValidationCmd],
  information: {
    definiteArticle: false,
    single: 'Ordeningskader',
    plural: 'Ordeningskaders',
    category: 'GENERAL',
  },
  websiteHref: null,
  createModal: {
    authors: {
      addUser: true,
    },
  },
  buildingBlocks: [{ type: NodeType.THEME }],
  tocTypes: [NodeType.THEME],
  edit: [titleComponent, authorsComponent],

  isSearchable: true,
  isCreatable: true,
  allowSuggestions: false,
};

export default REFERENCE_FRAME;
